import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'haScheduleShareDocPipe'
})
export class HaScheduleShareDocPipePipe implements PipeTransform {
//searchTermDoctorrrr
transform(doctorData: any[], searchTermDoctorrrr: string): any[]{
  if (!doctorData || !searchTermDoctorrrr) { return doctorData; }
  return doctorData.filter(ad =>
   
  
    ad.name.toLowerCase().indexOf(searchTermDoctorrrr.toLowerCase().trim()) !== -1
   




  );
}

}
